import React from "react";
import ReactDom from "react-dom/client";
import { App } from "./component/App";
import "./styles/index.scss";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { silenceAxiosTransportOverlay } from "./hooks/helperData/axiosTransportError";
//for use ggogle map ,using bootstrap and jq is neceessary
// import $ from 'jquery';
// import Popper from 'popper.js';
import "bootstrap/dist/js/bootstrap.bundle.min";
import "antd/dist/antd.min.css";
// import './index.css';
import "./i18n/i18n";

silenceAxiosTransportOverlay();

const root = ReactDom.createRoot(document.getElementById("root"));
root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
);
// Service worker caches old bundles and breaks auth/API updates after deploy.
// serviceWorkerRegistration.register();
